// Issue with i18n plugin, cant access locales from components.
// Injecting i18n to context fixed problem.
import Vue from 'vue';

export default ({ app }, inject) => {
  const { i18n, localePath } = app;

  if (process.env.SPA) {
    Vue.mixin({
      methods: {
        localePath(...args) {
          const raw = localePath.call(app, ...args);
          return raw.replace('#/', '/');
        },
      },
    });
  }

  inject('lang', i18n);
};
